import { createFileRoute } from "@tanstack/react-router"
import DesignSystemButtons from "~/pages/design-system/components/Buttons"

export const Route = createFileRoute("/_auth/internal/design-system/components/buttons")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemButtons />
}
